// extracted by mini-css-extract-plugin
var _1 = "uiehj";
var _2 = "noOo5";
var _3 = "rk3E8";
var _4 = "ebw0l";
export { _1 as "categorySizeCompact", _2 as "categorySizeFull", _3 as "categorySizeFullOrMedium", _4 as "categorySizeMediumOrCompact" }
